<div class="collapse-icon">
  <button (click)="toggleCollapsedImage.emit()" class="button_zomm">
    <!-- ícone -->
  </button>
</div>

<div class="overflow-hidden">
  <div class="button_area">
    <div class="zoom-controls">
      <button (click)="zoomIn()" class="button_zomm">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>
      </button>
      <button (click)="zoomOut()" class="button_zomm">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>
      </button>
      <button (click)="rotateImage()" class="button_zomm">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"> <path d="M2.5 2v6h6M21.5 22v-6h-6"/><path d="M22 11.5A10 10 0 0 0 3.2 7.2M2 12.5a10 10 0 0 0 18.8 4.2"/></svg>
      </button>
      <button (click)="abrirImagemBase64()" class="button_zomm">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><path d="M20.4 14.5L16 10 4 20"/></svg>
      </button>
      <button (click)="toggleCollapsedImage.emit()" class="button_zomm">
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="rotate180"><path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M13.8 12H3"/></svg>
      </button>
    </div>

    <div class="filename">{{ filenameText }}</div>

    <div class="flex">
      <div class="button_back">
        <button type="button" class="back remove" (click)="voltar.emit()" i18n>
          {{ 'Voltar' | translate }}
        </button>
      </div>
      <div class="button_back" *ngIf="temAnterior">
        <button type="button" class="back remove" (click)="anterior.emit()" i18n>
          {{ 'Receita anterior' | translate }}
        </button>
      </div>
    </div>
  </div>

  <div #imageContainer class="image-container" [style.transform]="'scale(' + zoom + ')'">
    <img #image [src]="blobImage" alt="Zoomable Image" class="zoomImage" (mousedown)="startDrag($event)" />
  </div>
</div>
